import { engineComponent, StringUtils, Utils } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";
import { HtmlContainerElement } from "../Elements/HtmlContainerElement";
import { HtmlButtonElement } from "../Elements/HtmlButtonElement";
import { HtmlController } from "../HtmlController";
import { AppContext } from "../../../Common/AppContext";
import { DataManager } from "../../Managers/DataManager";
import { PlayList } from "../../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.HtmlElement)
export class HtmlSoundContainerElement extends HtmlContainerElement {
    // private _levels: Array<string> = ['0%', '25%', '50%', '100%'];
    private _levels: Array<string> = ["", "", "", ""];
    private _levelsClasses: Array<string> = ["_off", "_on1", "_on2", "_on3"];
    private _index: number = 3;

    private _popup: HTMLDivElement;
    private _backgroundSound: HTMLDivElement;
    private _values: Array<HTMLDivElement>;
    private _soundButton: HTMLDivElement;

    private _height: string;

    protected block: boolean;
    protected timeout: number;

    constructor() {
        super();

        HtmlController.SoundContainer = this;
    }

    create(node: Element): void {
        super.create(node);

        this._soundButton = <HTMLDivElement>document.getElementById("soundButton");

        this._popup = <HTMLDivElement>document.createElement("div");
        this._popup.classList.add("display");
        this._popup.classList.add("popupSmall");

        if (AppContext.current.isBackgroundMusicEnabled) {
            this._backgroundSound = <HTMLDivElement>document.createElement("div");
            this._backgroundSound.classList.add("popupItem");
            let backgroundSoundChild: HTMLDivElement = <HTMLDivElement>document.createElement("div");
            backgroundSoundChild.classList.add("popupValue");
            backgroundSoundChild.classList.add("bgSound");
            if (AppContext.current.getBackgroundMusic()) {
                backgroundSoundChild.classList.add("_on");
            } else {
                backgroundSoundChild.classList.add("_off");
                DataManager.BackSoundsPlayingFromGame = false;
                PlayList.stopAllInGroup("BackgroundMusic");
            }
            backgroundSoundChild.onclick = this.onBackgroundClick.bind(this);
            this._backgroundSound.appendChild(backgroundSoundChild);
        }

        if (this.instance != null) {
            this.instance.appendChild(this._popup);
            if (this._backgroundSound != null) {
                this._popup.appendChild(this._backgroundSound);
            }
            if (AppContext.current.isBackgroundMusicEnabled) {
                this._popup.parentElement.classList.add("bgOn");
            }
        }

        this.addValues();

        this.block = true;
        this.createTimeout();
    }

    addValues(): void {
        if (this._values == null && this._popup != null) {
            this._values = [];

            for (let i: number = 0; i < this._levels.length; i++) {
                let popupItem: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                popupItem.classList.add("popupItem");
                popupItem.onclick = this.onValueClick.bind(this);
                popupItem.setAttribute("Level", i.toString());
                let popupItemValue: HTMLDivElement = <HTMLDivElement>document.createElement("div");
                popupItemValue.classList.add("popupValue");
                popupItemValue.innerText = this._levels[i];
                popupItem.appendChild(popupItemValue);

                if (i == 0 && !AppContext.current.isMuteVolumeAllowed) {
                    popupItem.style.display = "none";
                }

                this._values.push(popupItem);
                this._popup.appendChild(popupItem);
            }
            if (!AppContext.current.isMuteVolumeAllowed) {
                if (AppContext.current.isBackgroundMusicEnabled) {
                    this._height = 60 + ((this._levels.length - 1) * 60 + 48) + "px";
                } else {
                    this._height = (this._levels.length - 1) * 60 + 48 + "px";
                }
            } else {
                if (AppContext.current.isBackgroundMusicEnabled) {
                    this._height = 60 + (this._levels.length * 60 + 48) + "px";
                } else {
                    this._height = this._levels.length * 60 + 48 + "px";
                }
            }
        }
    }

    private onValueClick(e: any): void {
        if (this.block) {
            return;
        }

        this.setTimeout();
        if (e != null && e.currentTarget != null && e.currentTarget.hasAttribute("Level")) {
            PlayList.play("SND_Click");
            let level: number = parseFloat(e.currentTarget.getAttribute("Level"));
            if (level === this._index) {
            } else {
                this._index = level;
                if (this._values != null) {
                    for (let i: number = 0; i < this._values.length; i++) {
                        if (this._values[i].hasAttribute("Level")) {
                            if (parseFloat(this._values[i].getAttribute("Level")) === level) {
                                this._values[i].classList.add("_active");
                            } else {
                                this._values[i].classList.remove("_active");
                            }
                        }
                    }
                }
                AppContext.current.setVolume(level);
            }
        }
        this.changeSoundButton();
    }

    private onBackgroundClick(e: any): void {
        if (this.block) {
            return;
        }

        this.setTimeout();
        if (e != null && e.currentTarget != null) {
            PlayList.play("SND_Click");
            if (e.currentTarget.classList.contains("_on")) {
                e.currentTarget.classList.remove("_on");
                if (!e.currentTarget.classList.contains("_off")) {
                    e.currentTarget.classList.add("_off");
                }
                DataManager.BackSoundsPlayingFromGame = false;
                AppContext.current.setBackgroundMusic(false);
                PlayList.stopAllInGroup("BackgroundMusic");
            } else {
                e.currentTarget.classList.remove("_off");
                if (!e.currentTarget.classList.contains("_on")) {
                    e.currentTarget.classList.add("_on");
                }
                DataManager.BackSoundsPlayingFromGame = true;
                AppContext.current.setBackgroundMusic(true);
                PlayList.stopAllInGroup("BackgroundMusic", true);
            }
        }
    }

    setLevel(level: number): void {
        this._index = level;
        if (this._values != null) {
            for (let i: number = 0; i < this._values.length; i++) {
                if (i === level) {
                    if (!this._values[i].classList.contains("_active")) {
                        this._values[i].classList.add("_active");
                    }
                } else {
                    this._values[i].classList.remove("_active");
                }
            }
        }
        this.changeSoundButton();
    }

    changeSoundButton(): void {
        if (this._soundButton != null) {
            if (this._levelsClasses[this._index] != null) {
                for (let i: number = 0; i < this._levelsClasses.length; i++) {
                    this._soundButton.classList.remove(this._levelsClasses[i]);
                }
                this._soundButton.classList.add(this._levelsClasses[this._index]);
            }
        }
    }

    toggle(): void {
        if (this.instance != null) {
            if (this.instance.classList.contains("_disabled")) {
                this.block = false;
                this.setTimeout();
                if (this._height != null) {
                    this.instance.style.height = this._height;
                }
                this.instance.classList.remove("_disabled");
            } else {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    disable(): void {
        if (this.instance != null) {
            if (!this.instance.classList.contains("_disabled")) {
                this.block = true;
                this.clearTimeOut();
                this.instance.removeAttribute("style");
                this.instance.classList.add("_disabled");
            }
        }
    }

    protected createTimeout(): void {
        this.timeout = null;
    }

    protected setTimeout(): void {
        this.clearTimeOut();

        const duration = AppContext.gameConfiguration.SelectorRolloutDuration;

        if (duration > 0) {
            this.timeout = setTimeout((): void => {
                this.disable();
            }, duration * 1000);
        }
    }

    protected clearTimeOut(): void {
        if (!Utils.isNullOrUndefined(this.timeout)) {
            clearTimeout(this.timeout);

            this.timeout = null;
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Custom/HtmlSoundContainerElement.ts
 **/